import { ButtonAsLink } from 'css/components/Modules/Buttons';
import { StyledCheckbox } from 'css/components/Modules/Inputs';
import React from 'react';
import styled from 'styled-components';
import { theme, typeScale } from 'css/utils';

const PrivacyPolicyCheckboxWrapper = styled.div`
  /* color: ${theme.textFaded}; */ // TODO: Remove once confirmed
  color: #000;
  ${typeScale.textMd};
`;

interface PrivacyPolicyCheckboxProps {
  onStatusChangeHandler: (checked: boolean) => void;
  checkboxDescription: string;
  showPriceDisclaimer: boolean;
}

const PrivacyPolicyCheckbox: React.FC<PrivacyPolicyCheckboxProps> = ({
  onStatusChangeHandler,
  checkboxDescription,
  showPriceDisclaimer
}) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onStatusChangeHandler && onStatusChangeHandler(e.target.checked);
  };
  return (
    <PrivacyPolicyCheckboxWrapper className='mt-3 mb-4 d-flex'>
      <StyledCheckbox>
        <input
          className='styled-checkbox'
          id='styled-checkbox-1'
          type='checkbox'
          onChange={onChange}
        />
        <label htmlFor='styled-checkbox-1'></label>
      </StyledCheckbox>
      <span className='text-start'>
        By checking this box, you agree to our&nbsp;
        <ButtonAsLink
          type='button'
          modifiers={['faded', 'bold']}
          onClick={() => window.open('https://www.toro.com/en/legal/privacy-policy', '_blank')}
        >
          Privacy Policy
        </ButtonAsLink>{' '}
        and{' '}
        <ButtonAsLink
          type='button'
          modifiers={['faded', 'bold']}
          onClick={() =>
            window.open('https://www.toro.com/en/legal/Horizon360-SaaS-Agreement', '_blank')
          }
        >
          Terms of Service
        </ButtonAsLink>
        <>{`${checkboxDescription ? checkboxDescription : '.'}`}</>
        {showPriceDisclaimer && (
          <h2 className='text-lg my-3 text-black font-weight-bold'>All Pricing in USD</h2>
        )}
      </span>
    </PrivacyPolicyCheckboxWrapper>
  );
};

export default PrivacyPolicyCheckbox;
